<template>
	<b-card no-body class="m-0">
		<b-card-header header-tag="header" class="p-0" role="tab">
			<b-button block v-b-toggle.accordion-tag variant="light" class="py-4 accordion-button">SEGURO AUTOMOTRIZ</b-button>
		</b-card-header>
		<b-collapse id="accordion-tag" accordion="services-accordion" role="tabpanel">
			<b-card-body>
				<div class="text-center pb-4">
					<b-img src="images/tabs/mobile/seguro/asegurado.png" alt="llevatelo" style="width: 85%" />
				</div>
				<b-table-simple borderless>
					<b-tr>
						<b-td colspan="2" style="font-size: 15px" class="text-right m-0 py-0">
							<b>PLANES MENSUALES DESDE</b>
						</b-td>
					</b-tr>
					<b-tr>
						<b-td style="border-right: 2px solid #000; font-size: 27px;" class="text-right m-0 py-0">
							0,7 UF/MES
						</b-td>
						<b-td class="py-0 m-0" style="font-size: 27px;">
							10 UF Deducible
						</b-td>
					</b-tr>
					<b-tr>
						<b-td colspan="2">
							<b-img src="images/tabs/mobile/seguro/coberturas.png" alt="cobertura" fluid-grow />
						</b-td>
					</b-tr>
				</b-table-simple>
				<interested :service_type_id="3"></interested>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<script>
import Interested from '../components/interested';
  export default {
	name: 'v-tab-tag',
	components:{
		Interested
	},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>